import { detect, fromNavigator } from '@lingui/detect-locale';
import { Locale, de, enGB, fi, fr, nb, nl, sv } from 'date-fns/locale';

export const languages = ['en', 'no', 'fr', 'nl', 'de', 'sv'] as const;
export type Language = (typeof languages)[number];

export const isSupportedLanguage = (language?: string | null): language is Language =>
  languages.includes(language as Language);

const defaultLanguage = 'en';
export const defaultLocale = 'en-GB';

const localeLangMapping: Record<string, Language> = {
  nb: 'no',
  nn: 'no',
};

export const getLanguage = (language?: string | null): Language =>
  isSupportedLanguage(language) || language === 'fi' ? (language as Language) : defaultLanguage;

export const getLanguageFromLocale = (locale?: string | null) => {
  const langFromLocale = locale?.split(/[-|_]/)[0]?.toLowerCase() || '';
  const language = localeLangMapping[langFromLocale] || langFromLocale;

  return isSupportedLanguage(language) ? language : undefined;
};

export const browserLocale = detect(fromNavigator()) || defaultLocale;

export const browserLanguage = getLanguageFromLocale(browserLocale) || defaultLanguage;

const dateFnsLocaleMap: Record<Language | 'fi', Locale> = {
  de,
  en: enGB,
  fr,
  nl,
  no: nb,
  sv,
  fi,
};

export const getDateFnsLocale = (language?: Language | 'fi' | string): Locale => {
  const lang = (language || 'en') as Language | 'fi';
  return dateFnsLocaleMap[lang] || enGB;
};
